<template>
  <div v-if="flights.length > 0">
    <div class="tools">
      <div class="filter">
        <!-- <div class="space">
          <div class="label">
            Filter by
          </div>

          <div class="dropdown">
            <div class="bar">
              <div class="selection">
                {{filtering.selection.display}}
              </div>
              <div v-if="menu" class="menu-box">
                <div class="menu" v-for="option in filtering.options">
                  <div class="option" v-on:click="sort(option)">{{option.display}}</div>
                </div>
              </div>
              <div class="button" v-on:click="menu = !menu" v-bind:class="{ active: menu }">
                <i class="fa fa-caret-down"></i>
              </div>
            </div>

          </div>

          <div class="dropdown">
            <div class="bar">
              <div class="selection">
                {{selection}}
              </div>
              <div v-if="menu" class="menu-box">
                <div class="menu">
                  <div class="option">Cheapest First</div>
                  <div class="option">Most Expensive First</div>
                  <div class="option">Longest in Days</div>
                  <div class="option">Shortest in Days</div>
                </div>
              </div>
              <div class="button" v-on:click="menu = !menu" v-bind:class="{ active: menu }">
                <i class="fa fa-caret-down"></i>
              </div>
            </div>

          </div>
        </div> -->
      </div><div class="sort">
        <div class="space">
          <div class="label">
            Sort by
          </div>

          <div class="dropdown">
            <div class="bar" v-click-outside="onClickOutside">
              <div class="selection" v-on:click="sorting.menu = !sorting.menu">
                {{sorting.selection.display}}
              </div>
              <div v-if="sorting.menu" class="menu-box">
                <div class="menu" v-for="option in sorting.options">
                  <div class="option" v-on:click="sort(option)">{{option.display}}</div>
                </div>
              </div>
              <div class="button" v-on:click="sorting.menu = !sorting.menu" v-bind:class="{ active: sorting.menu }">
                <i class="fa fa-caret-down"></i>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
    <ul>
      <li v-for="flight in flights">
        <flight :flight="flight" />
      </li>
    </ul>
  </div>
  <div v-else>Sorry, there are no flights currently available for this origin and destination.</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Flight from './Flight'

export default {
  name: 'flights',
  data: function () {
    return {
      attractions: false,
      menu: false,
      selection: 'Cheapest First',
      sorting: {
        menu: false,
        selection: {
          display: 'Cheapest First',
          key: 'price',
          direction: 'asc'
        },
        options: [
          {
            display: 'Cheapest First',
            key: 'price',
            direction: 'asc'
          },
          {
            display: 'Expensive First',
            key: 'price',
            direction: 'desc'
          },
          {
            display: 'Shortest First',
            key: 'duration',
            direction: 'asc'
          },
          {
            display: 'Longest First',
            key: 'duration',
            direction: 'desc'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      flights: state => state.flights[state.origin.id] && state.flights[state.origin.id][state.destination.id] || [],
      filtering: state => {
        return {
          menu: false,
          selection: {
            display: 'No Filter',
            key: 'none',
            filtering: {
              menu: false,
              selection: {
                display: 'No Filter',
                key: 'none'
              }
            }
          },
          options: [
            {
              display: 'Duration',
              key: 'duration',
              options: state.flights.map(function (flight) {
                return flight.trip.duration
              })
            }
          ]
        }
      }
    })
  },
  methods: {
    onClickOutside (event) {
      this.sorting.menu = false
    },
    sort (option) {
      this.sorting.menu = false
      this.sorting.selection = option
      return this.flights.sort(function (a, b) {
        var x = null
        var y = null

        switch (option.key) {
          case 'price':
            x = a.price
            y = b.price
            break
          case 'duration':
            x = a.trip.duration
            y = b.trip.duration
            break
        }
        if (option.direction === 'asc') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        } else {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0))
        }
      })
    },
    ...mapActions([
      'chooseFlight'
    ])
  },
  components: {
    Flight
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
li {
  display: inline-block;
  min-width: 160px;
  width: 100%;
}
.tools {
  width: 100%;
}
.box {
  margin: 3px;
  border-radius: 3px;
  text-align: left;
  background-color: #fff;
  color: #8f8f8f;
    text-shadow: none;
box-shadow: 1px 1px 1px #939393;
}
.filter {
  width: 60%;
  display: inline-block;
}
.filter .dropdown {
  margin-right: 7px;
}
.sort {
  width: 40%;
  display: inline-block;
}
.space {
  display: flex;
  align-items: center;
  margin: 3px;
}
.label {
  margin-right: 7px;
  font-size: 14px;
  color: #777;
  user-select: none;
}
.bar {
  display: flex;
  /*margin: 3px;*/
  border-radius: 3px;
  text-align: left;
  background-color: #fff;
  color: #8f8f8f;
    text-shadow: none;
box-shadow: 1px 1px 1px #939393;
flex-grow: 1;
position: relative;
}
.dropdown {
  flex-grow: 1;
  user-select: none;
  position: relative;
}
.selection {
  flex-grow: 1;
  padding: 3px 7px 4px;
  font-size: 14px;
  color: #555;
  user-select: none;
  cursor: pointer;
}
.button {
  width: 26px;
  justify-content: center;
  display: flex;
  align-items: center;
  border-left: 1px solid #ededed;
  /*color: #555;*/
}
.button:hover {
  background: #ededed;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  cursor: pointer;
}
.button.active {
  background: #ededed;
}
.menu-box {
  position: absolute;
  top: 100%;
  width: 100%;
  text-align: left;
  margin-top: 2px;
  margin-right: 26px;
}
.menu {
  top: 100%;
  width: 100%;
  box-shadow: 1px 1px 1px #939393;
  text-align: left;
  background-color: #fff;
  color: #8f8f8f;

}
.option {
  font-size: 14px;
  text-align: left;
  padding: 3px 7px 4px;
  color: #555;
}
.option:hover {
  background: #dedede;
  cursor: pointer;

}
</style>



// WEBPACK FOOTER //
// Flights.vue?098b1750